export interface DailyPopularProductMedia {
  coverImage?: File;
  eraseCoverImage?: boolean;
  coverImageUrl?: string;
  videoURL?: string;
}

export const dailyPopularProductMediaFromResponse = (
  responseData: any,
): DailyPopularProductMedia => ({
  coverImageUrl: responseData.image_path,
  videoURL: responseData.video_url,
});
